import React, { useMemo } from 'react';
import {
  Typography,
  Grid,
  Dialog,
  DialogContent,
  makeStyles,
  createStyles,
  Theme,
  IconButton,
} from '@material-ui/core';
import { XCircle } from 'react-feather';
import { colors, H4Text } from 'design-system';

export type PolicySource = 'licensePlate' | 'vinNumber' | 'motorNumber' | '';

type Props = {
  open: boolean;
  onCloseRequested: () => void;
  source: PolicySource;
  licensePlate: string;
  vinNumber: string;
  motorNumber: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialoguePaper: {
      borderRadius: 10,
      padding: theme.spacing(2),
    },
    dialogueBackdrop: {
      background: 'rgba(5, 16, 35, 0.8)',
    },
    closeIcon: {
      position: 'absolute',
      top: theme.spacing(2),
      right: theme.spacing(2),
    },
    smallText: {
      fontSize: 14,
    },
  }),
);

const AlreadyInsuredErrorDialogue = ({
  open,
  onCloseRequested,
  source,
  licensePlate,
  vinNumber,
  motorNumber,
}: Props): JSX.Element => {
  const classes = useStyles();

  const message = useMemo((): React.ReactNode => {
    switch (source) {
      case 'licensePlate':
        return (
          <>
            para la placa <b>{licensePlate}</b>
          </>
        );
      case 'vinNumber':
        return (
          <>
            para el número de VIN <b>{vinNumber}</b>
          </>
        );
      case 'motorNumber':
        return (
          <>
            para el número de Motor <b>{motorNumber}</b>
          </>
        );
      default:
        return '';
    }
  }, [source, licensePlate, vinNumber, motorNumber]);

  return (
    <Dialog
      open={open}
      PaperProps={{
        className: classes.dialoguePaper,
      }}
      BackdropProps={{
        className: classes.dialogueBackdrop,
      }}
      maxWidth="xs"
      onClose={onCloseRequested}
    >
      <DialogContent>
        <IconButton
          id="sales-web-inspection-button-closealreadyinsured"
          data-testid="close-button"
          className={classes.closeIcon}
          onClick={onCloseRequested}
        >
          <XCircle color={colors.madison} />
        </IconButton>
        <Grid container spacing={2}>
          <Grid item xs={12} container justifyContent="center">
            <Typography variant="h1">¡Oops!</Typography>
          </Grid>
          <Grid item xs={12} container justifyContent="center">
            <img alt="" src="/images/already_insured_error_layout.svg" />
          </Grid>
          <Grid
            item
            xs={12}
            container
            justifyContent="center"
            alignItems="baseline"
          >
            <Typography
              variant="body2"
              align="center"
              style={{ display: 'inline' }}
            >
              Este auto ya está asegurado en ASSA.
            </Typography>
            <H4Text
              data-testid="message-label"
              style={{ fontSize: 12, display: 'inline' }}
              align="center"
              className={classes.smallText}
            >
              {message}
            </H4Text>
          </Grid>
          <Grid item xs={12} container justifyContent="center">
            <Typography
              variant="h4"
              align="center"
              className={classes.smallText}
            >
              Por favor contactar a tu corredor o llamar al 800-800-ASSA (2772)
              <br />
              para recibir asistencia.
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default AlreadyInsuredErrorDialogue;
